import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6273c4aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-multiselect-chips-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon = _resolveComponent("oxd-icon")!
  const _component_oxd_chip = _resolveComponent("oxd-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected, (option, index) => {
      return (_openBlock(), _createBlock(_component_oxd_chip, {
        key: `${index}-selected-${option.id}`,
        label: option.label,
        class: "oxd-multiselect-chips-selected"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_oxd_icon, {
            name: "x",
            onClick: ($event: any) => (_ctx.onClick(option)),
            class: _normalizeClass({
          '--clear': true,
          '--disabled': _ctx.disabled,
          '--readonly': _ctx.readonly,
        })
          }, null, 8, ["onClick", "class"])
        ]),
        _: 2
      }, 1032, ["label"]))
    }), 128))
  ]))
}